import React, { useState } from "react";
import Modal from "react-modal";
import heroImg from "../../assets/img/hero/dark.jpg";
import heroImgMobile from "../../assets/img/portfolio/KevBlkonBlkNoHatEdit1x1.jpg";
import cancelImg from "../../assets/img/cancel.svg";
import Index from "../../components/about/index";
import cv from "../../assets/img/portfolio/KevinEResume1225.pdf";
import backgroundImage from "../../assets/img/portfolio/KevBlkonBlkNoHatEditCompressed.jpg";

const heroContent = {
  heroImage: heroImg,
  heroMobileImage: heroImgMobile,
  heroTitleName: "Kevin",
  heroDesignation: "Web/Graphic Designer",
  heroDescriptions: `Front-end focused designer with a strong track record of building high-performing websites that increase traffic and support conversion goals through a mix of design, development, and data-driven decision-making.`,
};

const Hero = ({ goToPortfolio }) => {
  const [isOpen, setIsOpen] = useState(false);
  function toggleModalOne() {
    setIsOpen(!isOpen);
  }

  return (
    <>
      <div className="row home-details-container align-items-center">
        <div
          className="col-lg-4 bg position-fixed d-none d-lg-block"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        ></div>
        <div className="col-12 col-lg-8 offset-lg-4 home-details text-center text-lg-start">
          <div>
            <img
              src={heroContent.heroMobileImage}
              className="img-fluid main-img-mobile d-sm-block d-lg-none"
              alt="hero"
            />
            <h1 className="text-uppercase poppins-font">
              I'm {heroContent.heroTitleName}.
              <span>{heroContent.heroDesignation}</span>
            </h1>
            <p className="open-sans-font">{heroContent.heroDescriptions}</p>
            <button className="button" onClick={goToPortfolio}>
  <span className="button-text">View Portfolio</span>
  <span className="button-icon fa fa-arrow-right"></span>
</button>

<div className="col-12 mt-3">
  <a className="button" href={cv} download>
    <span className="button-text">Download CV</span>
    <span className="button-icon fa fa-download"></span>
  </a>
</div>

          </div>
        </div>
      </div>

      <Modal
        isOpen={isOpen}
        onRequestClose={toggleModalOne}
        contentLabel="My dialog"
        className="custom-modal dark hero"
        overlayClassName="custom-overlay dark"
        closeTimeoutMS={500}
      >
        <div>
          <button className="close-modal" onClick={toggleModalOne}>
            <img src={cancelImg} alt="close icon" />
          </button>

          <div className="box_inner about">
            <div data-aos="fade-up" data-aos-duration="1200">
              <div className="title-section text-left text-sm-center">
                <h1>
                  ABOUT <span>ME</span>
                </h1>
                <span className="title-bg">Resume</span>
              </div>
              <Index />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Hero;
